<template>
  <div 
    :id="'app' + config.id"
    :class="{ 'is-dark': config.is_dark }"
    class="v-content-carousel">
    <div v-if="status.ready">
      <carousel 
        v-if="items" 
        :ref="'carousel' + config.id"
        :pagination-enabled="false"
        pagination-position="bottom-overlay" 
        pagination-color="#aaa"
        pagination-active-color="#FFF"
        navigation-click-target-size="10"
        :navigation-enabled="true"
        :navigation-next-label="$icons.get('next', arrowClasses)"
        :navigation-prev-label="$icons.get('prev', arrowClasses)"
        :per-page-custom="perPage" 
        :autoplay-timeout="config.autoplay_timeout"
        :autoplay-hover-pause="true"
        :autoplay="false"
        :loop="config.autoplay == 1"
        @page-change="pageChanged"
        @mounted="init">
        <slide 
          v-for="(item, index) in items"
          :key="index">
          <a 
            :href="config.url + '/' + item.url"
            @mouseenter="paused = true"
            @mouseleave="paused = false">
            <content-card 
              :item="item">
            </content-card>
          </a>
        </slide>

        <!--<div class="grid-x" slot="navigation">
          <div class="cell shrink">
            <a @click="onChangeNavigation('backward')">
              Back
            </a>
          </div>
          <div class="cell auto text-center">
            dots
          </div>
          <div class="cell shrink">
            <a @click="onChangeNavigation('forward')">
              Next
            </a>
          </div>
        </div>-->

      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from '@jambonn/vue-concise-carousel'
import ContentCard from '@/ContentCard.vue'

export default {
  name: 'App',
  components: {
    ContentCard, Carousel, Slide
  },
  data () {
    return {
      status: {
        ready: false,
        error: false
      },
      timer: null,
      paused: true,
      seconds: null,
      currPage: 1,
      canAdvanceForward: true
    }
  },
  methods: {
    init () {
      if (this.config.autoplay) {
        this.timer = setInterval(this.countDown, 1000)
        this.seconds = this.config.autoplay_timeout
        const self = this
        document.addEventListener('scroll', function () {
          self.paused = !self.isInViewport()
        })
      }
    },
    countDown () {
      if (!this.paused) {
        if (this.seconds === 0) {
          this.carousel.handleNavigation('forward')
          this.seconds = this.config.autoplay_timeout
        } else {
          this.seconds = this.seconds - 1
        }
      }
    },
    startAutoplay () {
      this.paused = false
    },
    pauseAutoplay () {
      this.paused = true
    },
    isInViewport() {
      const el = this.$root.$el
      const viewport_width = document.documentElement.clientWidth
      const viewport_height = document.documentElement.clientHeight
      const el_rect = el.getBoundingClientRect()

      if (el_rect.left > 0 && el_rect.top > 0 && el_rect.right  < viewport_width && el_rect.bottom < viewport_height) {
        return true
      }

      return false;
    },
    cardStyles (item) {
      let obj = {}
      if (item.image) {
        obj.backgroundImage = 'url(' + item.image +')'
      }
      return obj
    },
    pageChanged (page) {
      this.currPage = page
    },
    onChangeNavigation(direction) {
      this.carousel.handleNavigation(direction)
    }
  },
  computed: {
    arrowClasses () {
      let classes = [
        'xlarge',
        (this.config.is_dark ? 'white' : 'black')
      ]
      return classes.join(' ')
    },
    carousel () {
      const ref = 'carousel' + this.config.id
      return this.$refs[ref]
    },
    config () {
      return this.$options.config
    },
    hasNextPage () {
      if (this.$refs.carousel) {
        return this.carousel.canAdvanceForward
      }
      return false
    },
    items () {
      if ('items' in this.config) {
        return this.config.items
      }
      return false
    },
    options () {
      let opt = {
        paginationPosition: 'bottom-overlay',
        paginationColor: '#aaa',
        paginationActiveColor: '#FFF',
        navigationClickTargetSize: 10,
        navigationEnabled: true,
        navigationNextLabel: this.$icons.get('next', 'xlarge black'),
        navigationPrevLabel: this.$icons.get('prev', 'xlarge black'),
        perPageCustom: this.perPage,
      }
      if (this.config.autoplay == 1) {
        opt.autoplay = this.config.autoplay_timeout
      }
      return opt
    },
    perPage () {
      return [
        [0, this.config.visible_items.small],
        [640, this.config.visible_items.medium],
        [1024, this.config.visible_items.large]
      ]
    }
  },
  mounted () {
    this.status.ready = true
  }
}
</script>
